// @flow
import React from "react";
import { css } from "styled-components";
import { ButtonLink } from "@nested/component-library";
import { ResponsiveImage } from "../../components/ResponsiveImage";

import {
  type Props,
  getFirstWord,
  getTextWithoutFirstWord,
  textStyles,
} from "./shared";

const imageWrapperStyles = css`
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 10px;
  width: calc(50% - 40px);
  z-index: 0;

  img {
    width: 100%;
    object-fit: cover;
    object-position: top;
  }
`;

const contentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  max-width: 574px;
  margin: 0 auto;
  overflow: hidden;
  padding: 40px 20px;
  position: relative;
`;

const textWrapperStyles = css`
  width: 50%;

  a {
    margin-top: 20px;
  }
`;

const sectionWrapperStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabletBuyingSellingSlice = ({
  buyingButtonLabel,
  buyingButtonLink,
  buyingImage,
  buyingText,
  buyingTitle,
  sellingButtonLabel,
  sellingButtonLink,
  sellingImage,
  sellingText,
  sellingTitle,
}: Props) => (
  <div css={textStyles}>
    <div
      css={css`
        ${sectionWrapperStyles}
        background-color: white;
      `}
    >
      <div
        css={css`
          ${contentWrapperStyles}
          align-items: flex-end;
        `}
      >
        <div
          css={css`
            ${imageWrapperStyles}
            right: calc(50% + 20px);
          `}
        >
          <ResponsiveImage src={sellingImage?.url} />
        </div>
        <div css={textWrapperStyles}>
          <h3>{sellingTitle}</h3>
          <p>
            <span>{getFirstWord(sellingText)}</span>{" "}
            {getTextWithoutFirstWord(sellingText)}
          </p>
          <ButtonLink
            size="large"
            to={sellingButtonLink?.url || "/"}
            type="primary"
          >
            {sellingButtonLabel || "Missing label"}
          </ButtonLink>
        </div>
      </div>
    </div>
    <div
      css={css`
        ${sectionWrapperStyles}
        background-color: ${({ theme }) => theme.palette.pink40};
      `}
    >
      <div css={contentWrapperStyles}>
        <div
          css={css`
            ${imageWrapperStyles}
            left: calc(50% + 20px);
          `}
        >
          <ResponsiveImage src={buyingImage?.url} />
        </div>
        <div css={textWrapperStyles}>
          <h3>{buyingTitle}</h3>
          <p>
            <span>{getFirstWord(buyingText)}</span>{" "}
            {getTextWithoutFirstWord(buyingText)}
          </p>
          <ButtonLink
            size="large"
            to={buyingButtonLink?.url || "/"}
            type="primary"
          >
            {buyingButtonLabel || "Missing label"}
          </ButtonLink>
        </div>
      </div>
    </div>
  </div>
);
